import React from 'react';
import { PLATFORMS, FOLLOW_SOCIALS } from '@/config/site';
import { ExtLink, SocialLink } from './Social';
import { mediaUrl } from '@/lib/api';

export default function ListenEverywhere({ platforms, socials }: { platforms: Record<string, string>; socials: Record<string, string> }) {
  const visiblePlatforms = PLATFORMS.filter((p) => (platforms[p.id] || '').trim());
  const visibleSocials = FOLLOW_SOCIALS.filter((id) => (socials[id] || '').trim());
  if (!visiblePlatforms.length && !visibleSocials.length) return null;
  return (
    <section id="listen" className="ek-listen" aria-labelledby="listen-title" data-testid="listen-everywhere-section">
      {visiblePlatforms.length > 0 && (
        <div className="ek-listen-left">
          <h2 id="listen-title" className="ek-small-title ek-le-title">LISTEN EVERYWHERE</h2>
          <div className="ek-platforms">
            {visiblePlatforms.map((p) => (
              <ExtLink
                key={p.id}
                url={platforms[p.id] || ''}
                label={p.label}
                className={`ek-platform ek-platform-${p.id}`}
                style={
                  {
                    ['--x' as string]: `${p.x}px`,
                    ['--w' as string]: `${p.w}px`,
                    ['--lx' as string]: `${p.logoX - p.x}px`,
                    ['--ly' as string]: `${p.logoY - 1335}px`,
                    ['--lw' as string]: `${p.logoW}px`,
                    ['--lh' as string]: `${p.logoH}px`,
                  } as React.CSSProperties
                }
                testId={`platform-${p.id}`}
              >
                <img src={mediaUrl(p.logo)} alt={p.label} draggable={false} />
              </ExtLink>
            ))}
          </div>
        </div>
      )}
      {visiblePlatforms.length > 0 && visibleSocials.length > 0 && (
        <span className="ek-listen-divider" aria-hidden="true" />
      )}
      {visibleSocials.length > 0 && (
        <div className="ek-listen-right">
          <h2 className="ek-small-title ek-ftj-title">FOLLOW THE JOURNEY</h2>
          <div className="ek-follow">
            {visibleSocials.map((id) => (
              <SocialLink
                key={id}
                id={id}
                url={socials[id] || ''}
                size={id === 'soundcloud' ? 24 : id === 'facebook' ? 19 : id === 'instagram' ? 21 : 20}
                className={`ek-fs ek-fs-${id}`}
                testPrefix="follow-social"
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
